import {Component, Input} from '@angular/core';
import {HcPair} from './models/hcpair';
import {ConfirmComponent} from './confirm.component';
import {DialogService} from 'ng2-bootstrap-modal';
import {PermanentaMedaljerComponent} from './permanenta.component';

@Component({
    selector: 'app-panel',
    templateUrl: './panel.component.html',
})
export class PanelComponent {
    @Input()
    pair: HcPair[];
    @Input()
    title: string;

    constructor(private dialogService: DialogService) {
    }

    showConfirm() {
        if (this.title === 'Permanenta medaljer') {
            this.dialogService.addDialog(PermanentaMedaljerComponent, {
                title: this.title,
                pair: this.pair
            }, {closeByClickingOutside: true, backdropColor: 'rgba(0, 0, 0, 0.5)'});
        } else {
            this.dialogService.addDialog(ConfirmComponent, {
                title: this.title,
                pair: this.pair
            }, {closeByClickingOutside: true, backdropColor: 'rgba(0, 0, 0, 0.5)'});
        }
    }
}



// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/panel.component.ts